import { Pipe, PipeTransform } from '@angular/core';
import { MatchQuality } from '@cpd-app/core-module/models';

/**
 * The seven names a match is allowed to have, from 02-home section 6.
 *
 * The enum's own key for 0 is "NA", which is an abbreviation of a database
 * value rather than something to show a member. Everything else matches, but
 * the map is written out in full so the displayed words live in one place and
 * cannot drift by somebody renaming an enum key.
 */
const MATCH_QUALITY_LABELS: Record<MatchQuality, string> = {
  [MatchQuality.NA]: 'Not Aligned',
  [MatchQuality.Poor]: 'Poor',
  [MatchQuality.Fair]: 'Fair',
  [MatchQuality.Good]: 'Good',
  [MatchQuality.Great]: 'Great',
  [MatchQuality.Excellent]: 'Excellent',
  [MatchQuality.Overqualified]: 'Overqualified'
};

/**
 * A match quality, as the word for it.
 *
 * 02-home section 6, and it is a rule rather than a preference: **matches are
 * named, never scored.** A percentage invents precision the underlying data
 * does not have, so there is no numeric form of this and no pipe that produces
 * one.
 *
 * Overqualified is the seventh value, not a failure state. It is information,
 * and nothing here or in the styles may treat it as a warning.
 *
 * An unscored dimension returns an empty string rather than "Not Aligned":
 * "we have not asked you yet" and "this does not suit you" are different
 * answers, and only the survey can tell them apart.
 */
@Pipe({ name: 'matchQuality' })
export class MatchQualityPipe implements PipeTransform {
  public transform(value: MatchQuality | number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }

    return MATCH_QUALITY_LABELS[value as MatchQuality] ?? '';
  }
}
